import { render, staticRenderFns } from "./ButtonWithIcon.vue?vue&type=template&id=b6c7cabc&scoped=true&"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithIcon.vue?vue&type=style&index=0&id=b6c7cabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c7cabc",
  null
  
)

export default component.exports